import { forwardRef } from "react";

// iter 372r — Contiguous-USA outline for the sidebar "OOS Shipping"
// item. iter 372s — path regenerated from the CC0 Wikimedia "Blank US
// Map": all lower-48 state polygons unioned (shapely), simplified and
// scaled to 24×24 — the real national outline instead of a hand-drawn
// approximation.
export const UsaIcon = forwardRef(function UsaIcon(
  { size = 24, className = "", strokeWidth = 1.4, ...rest },
  ref,
) {
  const { fill, stroke, ...passthrough } = rest;
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...passthrough}
    >
      <path d="M2.0 9.7L2.6 12.8L3.4 13.2L3.7 14.1L4.6 14.2L6.1 15.1L8.0 15.2L9.1 16.6L9.9 16.3L11.2 18.1L11.7 18.2L11.6 17.6L12.8 16.5L14.0 16.4L15.1 16.6L15.5 15.8L16.7 16.1L17.4 16.0L17.9 16.4L18.2 17.5L19.0 18.1L19.1 17.2L18.3 15.6L18.3 14.9L20.2 12.8L19.6 12.0L19.8 10.9L20.2 10.2L21.4 9.4L21.1 8.4L22.0 7.5L21.4 6.6L20.9 6.5L20.7 7.7L19.4 8.1L19.1 9.0L18.1 9.3L17.1 10.4L16.8 9.2L16.0 8.3L15.1 8.1L14.8 7.7L13.6 8.1L14.4 7.4L13.0 7.3L12.6 6.9L8.5 6.8L3.7 5.8L3.1 5.9L3.0 7.1Z" />
    </svg>
  );
});
